import React from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import FormContainer from "../Content";
import MaterialList from "../Content/MaterialList";

interface TabNavigationProps {
    validated: boolean;
    contactPerson: any;
    contactList: any;
    onChangeContactList: Function;
    onDeleteContactList: Function;
    onAddContactList: Function;
    onChangePersonContact: Function;
    mergeContactPerson: Function;
}

const TabNavigation = ({
    validated,
    contactList,
    contactPerson,
    onChangeContactList,
    onDeleteContactList,
    onAddContactList,
    onChangePersonContact,
    mergeContactPerson,
}: TabNavigationProps) => {
    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: (
                <FormContainer
                    contactList={contactList}
                    onChangePersonContact={onChangePersonContact}
                    onChangeContactList={onChangeContactList}
                    onDeleteContactList={onDeleteContactList}
                    onAddContactList={onAddContactList}
                    validated={validated}
                />
            ),
        },
        {
            label: "Vật tư cung cấp",
            labelEN: "select-materials",
            content: (
                <MaterialList
                    providerData={contactPerson}
                    mergeProvider={mergeContactPerson}
                />
            ),
        },
        {
            label: "Vật tư gia công",
            labelEN: "outsource-materials",
            content: (
                <MaterialList
                    providerData={contactPerson}
                    mergeProvider={mergeContactPerson}
                    relationKey="outsource_materials"
                    title="Danh sách vật tư gia công"
                    counterLabel="vật tư gia công"
                    priceColumnLabel="Giá gia công"
                    addButtonLabel="Thêm vật tư gia công"
                    emptyText="Không có vật tư gia công nào được chọn"
                    searchPlaceholder="Tìm kiếm vật tư gia công..."
                />
            ),
        },
    ];

    return <TabBar tabs={tabs} />;
};

export default TabNavigation;
